<template>
  <a-modal
    class="modal-content"
    :title="title || form.id ? '编辑' : '创建'"
    :width="870"
    :visible="visible"
    destroyOnClose
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <template>
      <a-form-model
        ref="ruleForm"
        :labelCol="{ span: 3 }"
        :wrapperCol="{ span: 20 }"
        :model="form"
        :rules="rules"
      >
        <a-form-model-item label="标题" prop="title">
          <a-input v-model="form.title" placeholder="请输入标题" />
        </a-form-model-item>
        <a-form-model-item label="上传封面" prop="coverUrl">
          <div class="flex-align-center">
            <j-image-upload
              ref="coverRef"
              accept=".png,.jpg,.jpeg"
              v-model="form.coverUrl"
              :otherData="{ compress: 1 }"
              bizPath="dayOath"
              @change="imgChange"
            />
            <!--            <span style="color: #cdcdcd">*建议封面尺寸444 * 252，大小不超过500kb</span>-->
          </div>
        </a-form-model-item>
        <a-form-model-item label="高考结束日期" prop="endDate">
          <a-date-picker v-model="form.endDate" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="权益" prop="memberId">
          <a-select
            mode="multiple"
            v-model="form.memberId"
            :options="memberOptions"
            placeholder="请选择权益"
          />
        </a-form-model-item>
        <a-form-model-item label="简介" prop="courseDesc">
          <a-textarea
            v-model="form.intro"
            placeholder="请输入简介"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import WangEditor from '@comp/WangEditor/index.vue'
import JImageUpload from '@comp/jeecg/JImageUpload.vue'
import JUpload from '@comp/jeecg/JUpload.vue'
import { getAction, postAction, putAction } from '@/api/manage'
import { getFileSuffix } from '@/utils/util'
import moment from 'moment'

export default {
  name: 'DayOathModal',
  components: {
    WangEditor,
    JImageUpload,
    JUpload,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    isShowSort: {
      type: Boolean,
      default: false,
    },
    cateDictCode: {
      type: String,
      default: '',
    },
    gradeDictCode: {
      type: String,
      default: '',
    },
    actionUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      current: 1,
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      itemLabelCol: { span: 5 },
      itemWrapperCol: { span: 18 },
      form: {},
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'change' }],
        coverUrl: [{ required: true, message: '请上传封面', trigger: 'change' }],
        endDate: [{ required: true, message: '请选择高考结束日期', trigger: 'change' }],
        memberId: [{ required: true, message: '请选择权益', trigger: 'change' }],
      },
      memberOptions: [],
    }
  },
  methods: {
    showModal(data) {
      this.getVipMembership()
      this.visible = true
      if (!data) return
      this.form = {
        id: data.id,
        title: data.title,
        memberId: data.memberId.split(','),
        coverUrl: data?.coverUrl,
        intro: data?.intro,
        endDate: data?.endDate,
      }
    },
    hideModal() {
      this.visible = false
      this.current = 1
      this.form = {}
    },
    imgChange(info) {
      // console.log('图片信息：', info)
    },
    async getVipMembership() {
      const res = await getAction('/aigoes/vipMembership/list')
      console.log('会员信息：', res)
      if (res.success) {
        this.memberOptions = res.result.records.map((item) => ({
          ...item,
          label: item.membershipType,
          value: item.id,
        }))
      }
    },
    handleOk() {
      console.log('点击保存')
      this.$refs.ruleForm.validate(async (valid) => {
        console.log('验证状态：', valid)
        if (!valid) return
        const cover = this.$refs['coverRef'].fileList.map((file) => {
          return { name: file.oldName, pic: file.response.message }
        })
        const params = {
          ...this.form,
          endDate: moment(this.form.endDate).format('YYYY-MM-DD'),
          memberId: this.form.memberId.join(','),
        }
        if (cover?.[0]?.pic) {
          params.coverUrl = cover?.[0]?.pic
        }
        const actionUrl = this.actionUrl.replace('/', '')
        const res = this.form.id
          ? await putAction(`/${actionUrl}/edit`, params)
          : await postAction(`/${actionUrl}/add`, params)
        console.log('创建：', res)
        if (res.success) {
          this.$message.success(res?.message || '创建成功')
          this.$emit('refreshData')
          this.hideModal()
        } else {
          this.$message.error(res?.message || '创建失败')
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-upload-picture-card-wrapper {
    width: auto;
  }
}
</style>
